export default function NoPage()
{
    return <h6>404</h6>
}
